
export default {
    name: 'OcTag',

    props: {
        variant: {
            type: String,
            default: 'infogrey',
            validator: function (value) {
                return (
                    [
                        'success',
                        'danger',
                        'notify',
                        'warning',
                        'information',
                        'infogrey',
                        'pine',
                        'salmon',
                        'brick',
                        'navy',
                        'mustard',
                        'terra',
                    ].indexOf(value) !== -1
                )
            },
        },
        light: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        backgroundColor() {
            return `bg-${this.variant}${this.light ? '-light' : ''}`
        },
        textColor() {
            if (this.light) {
                return `text-${this.variant}`
            }

            return ['notify', 'infogrey', 'brick', 'navy'].includes(this.variant)
                ? 'text-black'
                : 'text-white'
        },
    },
}
